/**
* @file Column component for displaying report links.
* @author Maarten Lensink
*/
import * as tslib_1 from "tslib";
import { ChangeDetectorRef } from '@angular/core';
import { AuthenticationService } from '../../authentication.service';
import { ComponentRegistry } from '../../core/component-registry';
import { ColumnProvider } from '../../base/column-provider';
import { ColumnBase } from '../../base/columns/column-base/column-base';
import { UserService } from '../../user.service';
import { SettingsService } from '../../settings.service';
/**
 * Column component for displaying a report link
 */
var ColumnReportLinkComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ColumnReportLinkComponent, _super);
    /**
     * Constructs a ColumnReportLinkComponent.
     * @param provider Provides the configuration information for the column.
     */
    function ColumnReportLinkComponent(provider, changeDetector, authenticationService, userService, settingsService) {
        var _this = _super.call(this, provider, changeDetector) || this;
        _this.authenticationService = authenticationService;
        _this.userService = userService;
        _this.settingsService = settingsService;
        return _this;
    }
    /**
     * Register this column class for the column provider.
     */
    ColumnReportLinkComponent.register = function () {
        ComponentRegistry.register('column', 'report-link', ColumnReportLinkComponent);
    };
    /**
     * Opens the report in a new tab.
     * @param {any} event The click event
     * @memberOf ColumnReportLinkComponent
     */
    ColumnReportLinkComponent.prototype.onClick = function (event) {
        event.stopPropagation();
        if (this.provider.value) {
            // Url is relative? Add backend base url.
            var urlIsRelative = this.provider.value.toLowerCase().indexOf('://') === -1;
            var backendBaseUrl = urlIsRelative ?
                this.settingsService.settings.frontend.versions.uri.toLowerCase().replace('breeze/version/info', '') + 'aspx/DwhReportViewer.aspx?Report=' : '';
            var backendRestUrl = urlIsRelative ?
                '&AccessToken=' + this.authenticationService.getAccessToken() + '&UserId=' + this.userService.user.Name : '';
            // Add Access Token as query parameter named 'AccessToken' and UserId as query parameter named 'UserId'.
            // Max url length = 2000-2048 characters. Auth0 Access Token is usualy shorter than 1KB. Symagic OpenId length is way shorter.
            // So we have about 1KB left for report parameters.
            var reportUrl = backendBaseUrl + this.provider.value + backendRestUrl;
            window.open(reportUrl, '_blank');
        }
    };
    return ColumnReportLinkComponent;
}(ColumnBase));
export { ColumnReportLinkComponent };
